export default "__VITE_ASSET__5689d2bd__"